import styled from 'styled-components'
import colors from 'globals/colors'

interface IndicationWrapperProps {
  hasError: boolean
}

export const IndicationWrapper = styled.div<IndicationWrapperProps>`
  font-size: 12px;
  line-height: 21px;
  color: ${colors.steelGrey};
  
  ${(props) => props.hasError && `
    color: ${colors.reddishPink};
  `};
`
